module.exports = __webpack_public_path__ + "static/media/KV01.f3d43a63.jpg";